import React from 'react';
import PropTypes from 'prop-types';
import { CardActions, CardHeader, CardText } from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import { editCompliance, openAssignUsersDialog, openClearUsersDialog } from '../../actions/ComplianceActionCreator';
import { asCard } from '../Common/Decorators';
import IconCompliance from 'material-ui/svg-icons/action/assignment-turned-in';
import Total from '../Display/Total';
import SkillChip from '../Skill/SkillChip';
import { Link } from 'react-router';
import { statusColours } from '../../constants/ColourConstants';

const renderSkills = (skills) => (skills && skills.length > 0 ) && (skills.map(({id, name}) => (<SkillChip key={id} skill={{id, name}} />)));

const getSubtitle = (skillCount) => (`${skillCount} ${skillCount === 1 ? 'skill' : 'skills'}`);


const ComplianceCard = ({id, name, skills, userCount, canEdit, canAssign}) => (
    <section>
        <CardHeader
            title={name}
            subtitle={getSubtitle(skills.length)}
            avatar={<IconCompliance color={statusColours.default} />}

        />
        <CardText className="cent-zero" >
            <div className="cent-content">
                <div className="content-left">
                    <Link className="a-block" to={`/dashboard/compliance/${id}/progress/user`} >
                        <Total
                            amount={userCount}
                            symbol=''
                            title='Users'
                            link={`/dashboard/compliance/${id}/progress/user`}
                        />
                    </Link>
                </div>
                <div className="content-main">
                    <CardText className="cent-card-chips">
                        {renderSkills(skills)}
                    </CardText>
                </div>
            </div>
        </CardText>
            <CardActions >
                {canEdit && <FlatButton label="Edit" onTouchTap={(() => editCompliance(id))}/>}
                {canAssign && <FlatButton label="Assign" onTouchTap={() => openAssignUsersDialog(id)} primary={true}/>}
                {canAssign && <FlatButton label="Clear" onTouchTap={() => openClearUsersDialog(id, userCount)} disabled={!userCount}/>}
            </CardActions>
    </section>
);

ComplianceCard.propTypes = {
    id: PropTypes.number,
    name: PropTypes.string.isRequired,
    skills: PropTypes.array,
    canEdit: PropTypes.bool,
    canAssign: PropTypes.bool,
};

ComplianceCard.defaultProps = {
    canEdit: false,
    canAssign: false,
    onEdit: editCompliance,
};

export default asCard(ComplianceCard);
